import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col">
          <h2 className="footer-logo">BRO'S RENTAL</h2>
          <p className="footer-desc">
            Established in 2024, BikeRent is a premium bike rental service
            offering top-quality rides and easy access to the city and trails,
            immersing you in an idyllic setting for a truly serene experience.
          </p>
        </div>
        <div className="social-links">
          <span>Stay Connected:</span>
          <a href="https://www.facebook.com/share/14oDTxkpodY/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
            </svg>
          </a>
          <a href="https://wa.me/918296695604"
            target="_blank"
            rel="noopener noreferrer">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor">
              <path d="M20.52 3.48A11.86 11.86 0 0 0 12.04 0C5.4 0 .04 5.36.04 12c0 2.12.55 4.2 1.6 6.03L0 24l6.14-1.61A11.93 11.93 0 0 0 12.04 24C18.68 24 24.04 18.64 24.04 12c0-3.19-1.24-6.19-3.52-8.52ZM12.04 21.82c-1.82 0-3.6-.49-5.16-1.42l-.37-.22-3.64.95.97-3.55-.24-.37A9.75 9.75 0 0 1 2.3 12c0-5.37 4.37-9.74 9.74-9.74 2.6 0 5.04 1.01 6.88 2.85A9.66 9.66 0 0 1 21.78 12c0 5.37-4.37 9.82-9.74 9.82Zm5.34-7.34c-.29-.15-1.71-.84-1.97-.93-.26-.11-.46-.15-.64.15-.18.29-.73.93-.89 1.12-.16.2-.33.22-.62.08-.29-.15-1.22-.45-2.33-1.42-.86-.77-1.45-1.71-1.62-2-.17-.29-.02-.45.13-.6.13-.13.29-.33.44-.49.15-.16.2-.29.29-.49.09-.2.04-.37-.02-.52-.07-.15-.64-1.55-.88-2.12-.23-.56-.46-.48-.64-.49h-.55c-.18 0-.48.07-.73.33-.26.29-.99.97-.99 2.37s1.02 2.74 1.16 2.93c.15.2 2.01 3.08 4.87 4.31.68.29 1.22.46 1.64.58.69.22 1.31.18 1.8.11.55-.08 1.71-.7 1.95-1.38.24-.68.24-1.27.17-1.38-.06-.11-.24-.18-.53-.33Z" />
            </svg>
          </a>
          <a href="https://www.instagram.com/bros_bike_rental_gokarna/"
            target="_blank"
            rel="noopener noreferrer" aria-label="Instagram">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
            </svg>
          </a>
        </div>
        <div className="footer-col">
          <center>
            <h3 className="footer-heading">Technical Support</h3>
          </center>
          <center>
            <p className="footer-contact">Tel: +91 8296695604</p>
            <p className="footer-contact">Tel: +91 9113238741</p>
            <p className="footer-contact">Tel: +91 8431057424</p>
          </center>
        </div>

      </div>

      <div className="footer-bottom">
        <div className="footer-copy">
          &copy; Copyright 2013-2024 BikeRent. All Rights Reserved.
        </div>
      </div>

      {/* <div className="footer-language">
        <span>English</span>
      </div> */}
    </footer>
  );
};

export default Footer;
